import { navLinks } from './geo';
import { useAuth } from '../../contexts/AuthContext';

// External-navigation link row — the web equivalent of the iOS
// navigationApp picker (Apple Maps / Google Maps).
// The driver's preferredNavigationApp setting (DriverSettingsView) sorts
// first and renders solid; the rest stay as secondary links since the web
// can't probe which apps are installed.
const APPS = [
  { key: 'google', label: 'Google Maps', emoji: '🚗' },
  { key: 'apple', label: 'Apple Maps', emoji: '🗺️' },
];

export default function NavButtons({ coords, name = '', address = '', compact = false }) {
  const { userProfile } = useAuth() || {};
  const preferred = userProfile?.preferredNavigationApp || userProfile?.navigationApp || '';
  const links = navLinks(coords, name, address);
  if (!links) return null;

  const ordered = [...APPS].sort((a, b) => {
    if (a.label === preferred) return -1;
    if (b.label === preferred) return 1;
    return 0;
  });

  const base = compact
    ? 'rounded-full px-3 py-1.5 text-[11px] font-bold'
    : 'rounded-xl px-3 py-2 text-xs font-bold';
  return (
    <div className="flex flex-wrap gap-2">
      {ordered.map(app => (
        <a
          key={app.key}
          href={links[app.key]}
          target="_blank"
          rel="noreferrer"
          className={`${base} ${
            app.label === preferred
              ? 'bg-blue-500 text-white shadow-sm'
              : 'bg-blue-50 text-blue-600'
          }`}
        >
          {app.emoji} {app.label}
        </a>
      ))}
    </div>
  );
}
